import script from "./UserTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=ts"

import "./UserTable.vue?vue&type=style&index=0&id=ff514b8c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff514b8c"]])

export default __exports__